module.exports = __webpack_public_path__ + "img/free-tag.d175d283.png";